import { $public } from '../http'
import { toQueryParams } from '../utils/query'

export default class BrowserToken {
  static async getBrowserToken(data) {
    return $public.post(
      `user/browser_token?${toQueryParams({
        serviceId: data?.serviceId,
        tokenType: data?.tokenType,
        parameters: data?.parameters,
      })}`,
    )
  }
}
